import { useCallback } from 'react';

export const useTracking = () => {
  const trackLead = useCallback(() => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      window.gtag('event', 'generate_lead', {
        currency: 'ARS',
        value: 1000
      });
    }
  }, []);

  return { trackLead };
};
